module.exports = __webpack_public_path__ + "img/logo-slogan.499f101e.png";